(function () {
  const cards = document.querySelectorAll('[data-hero-rotator]');
  if (!cards.length) return;

  cards.forEach((card) => {
    const images = card.querySelectorAll('.split-hero__image');
    if (images.length < 2) return;

    const interval = parseInt(card.dataset.interval, 10) || 4000;
    let index = 0;
    images[0].classList.add('is-active');

    let timer = null;

    function next() {
      images[index].classList.remove('is-active');
      index = (index + 1) % images.length;
      images[index].classList.add('is-active');
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(next, interval);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      },
      { threshold: 0.1 }
    );
    observer.observe(card);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else if (card.getBoundingClientRect().top < window.innerHeight) start();
    });
  });
})();
